import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Map} from 'immutable';

import configureApp from "core/configureApp";
import App from 'components/App';
// import registerServiceWorker from './registerServiceWorker';

// import './css/bootstrap.scss';
// import './css/index.scss';
// import './css/responsive.scss';
// import './css/theme.scss';
// import './css/all.css';

const initState = Map();
const {store, history} = configureApp(initState);

ReactDOM.render(
	<Provider store={store}>
		<App history={history} />
	</Provider>,
	document.getElementById('root')
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js